import StepCard from '__pages/AutomationEngine/Engine/Steps/StepCard';

type CardProps = {
  panel: any;
  addMenu: boolean;
  onSelectMenu: any;
  style: string;
  className: string;
  scale: number | null;
  position: { x: number; y: number } | null;
  onStart: (() => void) | null;
  onStop: (() => void) | null;
};

export const VariableCard = ({
  panel = null,
  addMenu = true,
  onSelectMenu = null,
  style,
  className,
  // Below props relate to dragging and we want to just ignore them
  scale = null,
  position = null,
  onStart = null,
  onStop = null,
  ...props
}: CardProps) => {
  return (
    <StepCard
      panel={panel}
      onSelectMenu={onSelectMenu}
      addMenu={addMenu}
      {...props}
    />
  );
};
